<template>
  <div>
    <pageTitle :extinfo="extinfo"></pageTitle>
    <div class="works-banner" :style="{'height': screenHeight + 'px'}">
      <van-image height="100%" width="100%" style="filter: opacity(20%);" fit="cover" :src="artFamous.coverUrl+'?x-oss-process=image/resize,l_750'"></van-image>
      <!-- <div class="banner-title">
        <p v-for="(item, index) in titleArray" :key="index">{{ item }}</p>
      </div> -->
      <img class="main-image" style="border: 1px solid #FFFFFF;box-shadow: 0px 10px 30px 0px rgba(91, 93, 98, 0.35);" :style="{'object-fit': mainFit,'left': left + 'px','top': top + 'px','height': lastHeight + 'px','width': lastWidth + 'px'}" :src="artFamous.coverUrl+'?x-oss-process=image/resize,l_750'" />
      <div class="tools">
        <div class="data">
          <div class="data-view">
            <van-image height="20" width="21" :src="require('@/assets/liulan_icon@2x.png')"></van-image>
            <div>{{ artFamous.pageView }}</div>
          </div>
          <div class="data-like">
            <van-image height="20" width="21" :src="require('@/assets/lick-icon.png')"></van-image>
            <div>{{ artFamous.pageLike }}</div>
            <wx-open-launch-app class="openApp" appid="wxa496fd5f0644bb66" :extinfo="extinfo" @error="openAppErr">
              <script type="text/wxtag-template">
                <div style="position: absolute; top: 0; left: 0;width: 100%; height:100%;opacity: 0;">
                此div必须有内容才可点击，但不能在页面上展示，固采用透明度隐藏此div
                </div>
              </script>
            </wx-open-launch-app>
          </div>
        </div>
        <van-image height="20" width="22" :src="require('@/assets/down_icon.png')"></van-image>
        <wx-open-launch-app class="openApp" appid="wxa496fd5f0644bb66" :extinfo="extinfo" @error="openAppErr">
          <script type="text/wxtag-template">
            <div style="position: absolute; top: 0; left: 0;width: 100%; height:100%;opacity: 0;">
            此div必须有内容才可点击，但不能在页面上展示，固采用透明度隐藏此div
            </div>
          </script>
        </wx-open-launch-app>
      </div>
      <!-- <div class="up-tag">
        <van-image height="15" width="15" :src="require('@/assets/up_icon.png')"></van-image>
      </div> -->
    </div>
    <div class="wd-box">
      <div class="wd-box-content">
        <div class="wd-box-title">{{ artFamous.title }}</div>
        <div class="name">{{ artFamous.artName }}/{{ artFamous.madeDate }}</div>
        <div class="desc">
          <div class="desc-item" v-if="artFamous.width&&artFamous.height">尺寸：{{artFamous.width}}cm x {{artFamous.height}}cm</div>
          <div class="desc-item" v-else>尺寸：--</div>
          <div class="desc-item" v-if="artFamous.artType">类型：{{artFamous.artType}}</div>
          <div class="desc-item" v-else>类型：--</div>
          <div class="desc-item" v-if="artFamous.material">材质：{{artFamous.material}}</div>
          <div class="desc-item" v-else>材质：--</div>
          <div class="desc-item" v-if="artFamous.source">来源：{{artFamous.source}}</div>
          <div class="desc-item" v-else>来源：--</div>
        </div>
      </div>
      <div class="section-title"><div class="left-line"></div>艺术鉴赏</div>
      <div class="brief">{{ artFamous.brief }}</div>
      <div class="section-title"><div class="left-line"></div>艺术家背景</div>
      <div class="art-avatar" v-if="artFamous.artUrl">
        <van-image height="240" width="100%" class="avatar-bg" :src="require('@/assets/artist_bg.png')"></van-image>
        <van-image height="240" width="240" fit="cover" :src="artFamous.artUrl + '?x-oss-process=image/resize,l_480'" ></van-image>
      </div>
      <div class="brief">{{ artFamous.artBrief }}</div>
      <div class="section-title"><div class="left-line"></div>往期回顾</div>
      <div class="history">
        <div class="history-item" v-for="(item, index) in history" :key="index">
            <wx-open-launch-app class="openApp" style="height:100%" appid="wxa496fd5f0644bb66" :extinfo="extinfo" @error="openAppErr">
          <script type="text/wxtag-template">
            <div style="position: absolute; top: 0; left: 0;width: 100%; height:100%;opacity: 0;">
            此div必须有内容才可点击，但不能在页面上展示，固采用透明度隐藏此div
            </div>
          </script>
        </wx-open-launch-app>
          <div class="image-box">
            <van-image fit="cover" height="100%" width="100%" style="padding: 8px 8px 20px 8px;box-sizing: border-box;" :src="item.coverUrl+'?x-oss-process=image/resize,l_750'"></van-image>
          </div>
          <div class="history-title">{{ item.title }}</div>
          <div class="history-info">{{item.artName}}/{{item.madeDate}}</div>
        </div>
      </div>
      <div style="padding: 0 20px;">
        <commen-list :commentList="commentList" :likeTotal="likeTotal" :commentTotal="commentTotal"></commen-list>
      </div>
    </div>
    <common-ct :likeCount="artFamous.pageLike" :commentCount="commentTotal" :extinfo="extinfo" @share="share" @common="common"
      @like="like"></common-ct>
    <pageFoot :extinfo="extinfo" v-show="isSuspension"></pageFoot>
  </div>
</template>
<script>
import { queryCommentLikeTotal, queryCommentList, getFamousDetailById, getFamousHistory } from '@/api/artinfo'
import pageTitle from '@/components/pageTitle/pageTitle.vue'
import pageFoot from '@/components/pageFoot/pageFoot.vue'
import commonCt from '@/components/commonCt/commonCt.vue'
import commenList from '@/components/commenList/commenList.vue'
import { queryShart } from '@/api/user'
import { wexinShare, changeTitleClick } from '@/utils/utils'
import { Swipe, SwipeItem } from 'vant'
export default {
  name: 'famousDetail',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    pageTitle,
    pageFoot,
    commonCt,
    commenList
  },
  data () {
    return {
      id: 0,
      artFamous: {},
      titleArray: [],
      // 评论列表
      commentList: [],
      commentTotal: 0,
      likeTotal: 0, // 点赞数
      screenHeight: window.innerHeight - 220,
      screenWidth: window.innerWidth,
      isSuspension: false,
      jump: 0,
      extinfo: 'yslt://?name=famousDetail&',
      imageHeight: 0,
      imageWidth: 0,
      lastHeight: 0,
      lastWidth: 0,
      mainFit: 'none',
      left: 0,
      top: 0,
      history: []
    }
  },
  async created () {
    this.getA()
    changeTitleClick('名画赏析')
    await this.getFamousDetailById()
    await this.getFamousHistory()
    await this.getCommonList()
    await this.queryCommentLikeTotal()
    this.weixin()
    this.extinfo = this.extinfo + `id=${this.id}`
  },
  mounted () {
    // 可以在这里面直接进行滚动条的获取
    window.addEventListener('scroll', this.scrollHandle)
  },
  methods: {
    toHistory (id) {
      const url = `http://room.yslt.art/SharePageTest?onSharePage=0&id=${id}#famousDetail`
      window.location.href = url
    },
    scrollHandle (e) {
      const top = e.srcElement.scrollingElement.scrollTop // 获取页面滚动高度
      if (top > 200) {
        this.isSuspension = true
      } else {
        this.isSuspension = false
      }
    },
    dealTitle (title, length) {
      if (title.length > length) {
        let t = title.substring(0, length)
        const tt = title.substring(length, title.length)
        t += '&' + this.dealTitle(tt, length)
        return t
      }
      return title
    },
    // 获取往期
    async getFamousHistory () {
      try {
        const res = await getFamousHistory({
          id: this.id
        })
        this.history = res.result
      } catch (error) {
        console.log('获取名获取往期失败', error)
      }
    },
    // 获取名画详情
    async getFamousDetailById () {
      try {
        const res = await getFamousDetailById({
          id: this.id
        })
        this.artFamous = res.result
        const title = this.dealTitle(this.artFamous.title, 6)
        this.titleArray = title.split('&')
        const that = this
        const img = new Image()
        img.src = this.artFamous.coverUrl + '?x-oss-process=image/resize,l_750'
        img.onload = function () {
          that.imageHeight = img.height
          that.imageWidth = img.width
          if (that.imageWidth > that.imageHeight) {
            if (that.imageWidth > (that.imageHeight * 3)) {
              that.imageWidth = that.imageHeight * 3
              that.mainFit = 'cover'
            }
            that.lastWidth = that.screenWidth * 0.8
            that.lastHeight = that.lastWidth / that.imageWidth * that.imageHeight
          } else {
            if (that.imageHeight > (that.imageWidth * 1.6)) {
              that.imageHeight = that.imageWidth * 1.6
              that.mainFit = 'cover'
            }
            that.lastWidth = that.screenWidth * 0.65
            that.lastHeight = that.lastWidth / that.imageWidth * that.imageHeight
          }
          that.top = that.screenHeight / 2 - that.lastHeight / 2 - 20
          that.left = that.screenWidth / 2 - that.lastWidth / 2
        }
      } catch (error) {
        console.log('获取名画详情失败', error)
      }
    },
    // 获取评论列表
    async getCommonList () {
      try {
        const res = await queryCommentList({
          topicId: this.id,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
        this.commentList = res.result.records
        this.commentTotal = res.result.total
      } catch (error) {
        console.log('评论数据列表失败', error)
      }
    },
    // 获取评论点赞
    async queryCommentLikeTotal () {
      try {
        const res = await queryCommentLikeTotal({
          topicId: this.id
        })
        this.likeTotal = res.result.likeCount
      } catch (error) {
        console.log('获取评论列表失败', error)
      }
    },
    // 预览图片
    proImag (img) {
    },
    // 获取url参数
    getA () {
      const geturl = window.location.href
      const seturl = geturl.split('#')[0]
      const getqyinfo = seturl.split('?')[1]
      const getqys = getqyinfo.split('&')
      const obj = {} // 创建空对象，接收截取的参数
      for (let i = 0; i < getqys.length; i++) {
        const item = getqys[i].split('=')
        const key = item[0]
        const value = item[1]
        obj[key] = value
      }
      this.id = obj.id
    },
    // 微信二次分享
    async weixin () {
      const res = await queryShart({ url: `${location.href.split('#')[0].toString()}` })
      console.log(res)
      this.$nextTick(() => {
        wexinShare(res.result, {
          title: this.artFamous.title,
          desc: this.artFamous.artName + '/' + this.artFamous.madeDate,
          link: `http://room.yslt.art/SharePageTest/?id=${this.id}#/famousDetail`,
          imgUrl: this.artFamous.pageUrl
        })
      })
    },
    openAppErr () {
      window.open('https://a.app.qq.com/o/simple.jsp?pkgname=yslt.art.app', '_blank')
    },
    share () {
      // this.open()
    },
    common () {
      // this.open()
    },
    like () {
      // this.open()
    }
  }
}
</script>
<style lang="scss" scoped>
.works-banner {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, #FFF2E0 1%, #F8F8F8 100%);
  .banner-title {
    font-weight: 500;
    color: #94653D;
    writing-mode: vertical-lr;
    filter: opacity(50%);
    letter-spacing: 20px;
    position: absolute;
    left: 20px;
    font-size: 70px;
    margin-top: -50px;
  }
  .main-image {
    position: absolute;
  }
  .tools {
    position: absolute;
    bottom: 16px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .data {
      display: flex;
      align-items: flex-start;
      .data-like {
        margin-left: 18px;
      }
      .data-view, .data-like {
        display: flex;
        align-items: center;
        justify-content: center;
        >div {
          margin-left: 8px;
          font-size: 12px;
          font-weight: 400;
          color: #727272;
        }
      }
    }
  }
  .up-tag {
    width: 100%;
    position: absolute;
    bottom: 36px;
    text-align: center;
  }
}
  .wd-box {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding-bottom: 80px;
    .wd-box-content {
      padding: 25px 20px 20px 20px;
      border-bottom: 1px solid #EEE;
      .wd-box-title {
        font-size: 26px;
        font-weight: 500;
        color: #A26F43;
      }
      .name {
        margin-top: 18px;
        font-size: 15px;
        color: #333;
        font-weight: 400;
      }
      .desc {
        margin-top: 20px;
        .desc-item {
          color: #666;
          font-size: 14px;
          font-weight: 400;
          line-height: 2;
        }
      }
    }
    .brief {
      white-space: pre-line;
      padding: 0 20px;
      color: #333;
      font-size: 16px;
      font-weight: 400;
      line-height: 1.8;
    }
    .art-avatar {
      padding: 0 20px;
      position: relative;
      text-align: center;
      margin-bottom: 20px;
      .avatar-bg {
        padding: 0 20px;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
      }
    }
    .history::-webkit-scrollbar {
      display: none;
    }
    .history {
      overflow-x: scroll;
      white-space: nowrap;
      padding: 0 12px;
      scrollbar-width: none;
      -ms-overflow-style: none;
      .history-item {
        display: inline-block;
        position: relative;
      }
      .history-item:not(:last-child) {
        margin-right: 8px;
      }
      .image-box {
        height: 180px;
        width: 100px;
        background: #FFF1E0;
        border: 1px solid #E8CFBB;
        position: relative;
      }
      .history-title {
        margin-top: 18px;
        font-weight: 500;
        color: #333;
        font-size: 14px;
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .history-info {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 400;
        color: #A26F43;
      }
    }
  }
  .section-title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      padding: 30px 17px 16px 17px;
      .more {
       color: #999999;
       font-size: 13px;
       font-weight: 400;
       float: right;
       margin-top: 4px;

       img {
        height: 10px;
        width: auto;
        margin-left: 8px;
       }
      }

    }
.left-line {
    width: 2px;
    height: 14px;
    background: linear-gradient(0deg, rgba(248, 243, 234, 0.3) 0%, #BCA992 100%);
    margin-right: 8px;
    display: inline-block;
}
.yslt-logo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 50px;
  border-bottom: 1px solid #eee;
  background: #fff;
  font-size: 0;
  .open-app {
    background: #C4946B;
    color: #fff;
    border-radius: 6px;
    font-size: 14px;
    width: 86px;
    height: 32px;
    line-height: 32px;
    text-align: center;
  }
}
.openApp {
  position: absolute;
  width: 100%;
  height: 60px;
  top: 0;
  left: 0;
  z-index: 1;
}
</style>
